import React from 'react';
import {
  FormGroup,
  FormControl,
  Col,
  HelpBlock,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { ServerErrors } from '../../../../util/Errors';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages } from 'react-intl';
import { RadioGroup, Radio } from 'react-radio-group';
import { get, uniqueId, find, isEmpty } from 'lodash';
import { getUserId, getTokenId, getJWT } from '../../../../redux/reducers/authenticationReducers';
import { ToastContainer, ToastMessage } from '../../../../lib';
import { injectIntl } from 'react-intl';
import {
  parsePrice,
  splitGoogleAddressComponents,
  addressToString,
} from '../../../../lib/helper';
import '../../../../public/css/Dashboard.css';
import { getUserAddressess, saveUserAddress } from '../../../../api/api';
import { Required, testRegex, checkNumber } from '../../../../lib/validator';
import defaultMsg from '../../../../translations/lang/en-US.json';
import { MdLoaderTheme } from '../../../common/Loading';

const ToastMessageFactory = React.createFactory(ToastMessage.animation);

class DeliveryAddressForm extends React.Component {
  getIntialState(props) {
    return {
      streetAddress: get(props, 'source.streetAddress', ''),
      zipCode: get(props, 'source.zipCode', ''),
      formattedAddress: get(props, 'source.formattedAddress', ''),
      deliveryAddress: get(props, 'source.deliveryAddress', ''),
      collapsed: get(props, 'source.collapsed', true),
      error: false,
      checkingForAvailavility: false,
      shortAddress: get(props, 'source.shortAddress', false),
      addressDetails: this.getAddressDetails(props),
      newAddress: !isEmpty(this.props.userId) ? false : true,
      listAddress: !isEmpty(this.props.userId) ? true : false,
      loading: !isEmpty(this.props.userId),
      errorLoadingAddress: false,
      addressList: [],
      savingAddress: false,
      addressName: '',
      addressId: false,
      editAddress: false,
      appartmentAddress: '',
    };
  }

  getAddressDetails(props) {
    return {
      postalCode: get(props, 'source.addressDetails.postalCode', ''),
      city: get(props, 'source.addressDetails.city', ''),
      state: get(props, 'source.addressDetails.state', ''),
      country: get(props, 'source.addressDetails.country', ''),
      locality: get(props, 'source.addressDetails.locality', ''),
      administratorLevel: get(
        props,
        'source.addressDetails.administratorLevel',
        ''
      ),
    };
  }

  constructor(props) {
    super(props);
    this.state = this.getIntialState(props);
    this.addressList = this.addressList.bind(this);
    this.handleStreetAddress = this.handleStreetAddress.bind(this);
    this.getAddresses = this.getAddresses.bind(this);
    this.editDeliveryAddress = this.editDeliveryAddress.bind(this);
    this.renderDeliveryInformation = this.renderDeliveryInformation.bind(this);
    this.selectNewAddress = this.selectNewAddress.bind(this);
    this.renderAddress = this.renderAddress.bind(this);
    this.handleAddressRadioChange = this.handleAddressRadioChange.bind(this);
    this.saveAddress = this.saveAddress.bind(this);
    this.handleAddressNameChange = this.handleAddressNameChange.bind(this);
    this.makeAddressPipeSeparated = this.makeAddressPipeSeparated.bind(this);
    this.getAddressObject = this.getAddressObject.bind(this);
    this.setPrimaryByDefault = this.setPrimaryByDefault.bind(this);
    this.selectNewList = this.selectNewList.bind(this);
    this.handleAppartmentAddress = this.handleAppartmentAddress.bind(this);
  }

  makeAddressPipeSeparated(data) {
    return !isEmpty(data)
      ? `${data.zipcode}|::|${data.address_1}|::|${
          !isEmpty(data.address_2) ? data.address_2 : ''
        }|::|${data.name}|::|${data.id}|::|${addressToString(data)}`
      : '';
  }

  componentDidMount() {
    const { deliveryInformation, userLocatedAddress } = this.props;
    if(!deliveryInformation){
      const google = window.google;
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { address: userLocatedAddress },
        (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            const deliveryAddress = splitGoogleAddressComponents(
              get(results[0], 'address_components', [])
            );
            this.findGeoLocationOnZipcode(deliveryAddress.zipCode);
            this.setState({
              zipCode: deliveryAddress.zipCode,
              streetAddress: deliveryAddress.streetAddress,
            });
          }
        }
      );
    }
  }

  editDeliveryAddress() {
    this.setState({
      shortAddress: false,
      editAddress: true,
      listAddress: false,
    });
    this.props.hideLocation();
  }

  addressList(data) {
    this.setState({
      addressList: data,
      listAddress: true,
      newAddress: false,
      loading: false,
      errorLoadingAddress: true,
    });
  }

  handleStreetAddress(e) {
    const streetAddress = e.target.value.substring(0, 300);
    this.setStreetAddress(streetAddress);
  }

  setStreetAddress = (streetAddress) => {
    this.setState({
      streetAddress: streetAddress,
      deliveryAddress: streetAddress
        ? `${streetAddress}${
            this.state.appartmentAddress
              ? ', ' + this.state.appartmentAddress
              : ''
          }, ${this.state.formattedAddress}`
        : this.state.formattedAddress,
    });
  }

  setNotValidZipCode = () => {
    this.setState({
      collapsed: true,
      error: 'Not a valid zip code.',
      formattedAddress: '',
      deliveryAddress: '',
      streetAddress: '',
      addressDetails: this.getAddressDetails(this.props),
    });
  }

  handleAppartmentAddress(e) {
    const address = e.target.value.substring(0, 300);
    this.setState({
      appartmentAddress: address,
      deliveryAddress: address
        ? `${
            this.state.streetAddress ? this.state.streetAddress + ', ' : ''
          } ${address}, ${this.state.formattedAddress}`
        : `${this.state.streetAddress ? this.state.streetAddress + ', ' : ''} ${
            this.state.formattedAddress
          }`,
    });
  }

  findGeoLocationOnZipcode = (zipCode) => {
    const google = window.google;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      { address: zipCode },
      (results, status) => {
        const formattedAddress = get(results, '0.formatted_address', '');
        if ( status === google.maps.GeocoderStatus.OK && formattedAddress ) {
          this.setState(
            {
              formattedAddress: formattedAddress,
              collapsed: false,
              error: false,
              addressDetails: splitGoogleAddressComponents(
                get(results[0], 'address_components', [])
              ),
            },
            () => { this.setStreetAddress(this.state.streetAddress);}
          );
        } else
          this.setNotValidZipCode();
      }
    );
  }

  handleAddressNameChange(e) {
    if (testRegex('^[a-zA-Z0-9_]*$', e.target.value)) {
      this.setState({ addressName: e.target.value });
    }
  }

  handleZipCodeChange = (e) => {
    const zipCode = e.target.value;
    this.findGeoLocationOnZipcode(zipCode);
    this.setState({
      zipCode: zipCode,
    });
  }

  handleAddressRadioChange(value) {
    const addressObject = this.getAddressObject(value);
    this.setState(addressObject);
    this.findGeoLocationOnZipcode(addressObject.zipCode);
  }

  getAddressObject(value) {
    const addressDetails = value.split('|::|');
    return {
      selectedValue: value,
      zipCode: addressDetails[0],
      streetAddress: addressDetails[1],
      appartmentAddress: addressDetails[2],
      addressName: addressDetails[3],
      addressId: addressDetails[4],
      deliveryAddress: addressDetails[5],
    };
  }

  componentWillMount() {
    if (!isEmpty(this.props.userId)) {
      this.setState({ loading: true });
      getUserAddressess(this.props).then(response => {
        const result = get(response, 'data.DataResponse', []);
        if (result.status !== 'success') {
          this.setState({
            loading: false,
            error: ServerErrors[505],
          });
        } else {
          this.setPrimaryByDefault(result.data);
        }
      });
    }

    if (this.state.shortAddress) {
      this.getAddresses();
    }
  }

  setPrimaryByDefault(data) {
    const primaryAddress = this.makeAddressPipeSeparated(
      find(data, item => item['is_primary'] === '1')
    );
    this.setState(
      Object.assign(
        {
          loading: false,
          addressList: data,
        },
        this.getAddressObject(primaryAddress)
      ),
      () => {
        this.findGeoLocationOnZipcode(this.state.zipCode);
      }
    );
  }

  getAddresses() {
    const isAddressInputed = this.state.deliveryAddress.length > 3;
    this.setState(
      {
        checkAvailability: isAddressInputed,
        shortAddress: isAddressInputed,
        newAddress: false,
        listAddress: false,
        editAddress: false,
      },
      function() {
        this.props.getAddresses(this.state.deliveryAddress, {
          zipCode: this.state.zipCode,
          streetAddress: this.state.streetAddress,
          formattedAddress: this.state.formattedAddress,
          addressDetails: this.state.addressDetails,
        });
      }.bind(this)
    );
  }

  selectNewAddress() {
    this.setState({
      newAddress: true,
      listAddress: false,
      editAddress: false,
      addressName: '',
      addressId: false,
      zipCode: '',
      streetAddress: '',
      addressDetails: '',
      formattedAddress: '',
      deliveryAddress: '',
      collapsed: true,
      shortAddress: false,
      appartmentAddress: '',
    });
    this.props.hideLocation();
  }

  selectNewList() {
    this.setState({
      listAddress: true,
      newAddress: false,
      editAddress: false,
      shortAddress: false,
    });
    this.props.hideLocation();
    this.setPrimaryByDefault(this.state.addressList);
  }

  saveAddress() {
    let currentState = {};
    currentState['zipcode'] = this.state.zipCode;
    currentState['address_2'] = this.state.appartmentAddress;
    currentState['address_1'] = this.state.streetAddress;
    currentState['state'] = this.state.addressDetails.state;
    currentState['country'] = this.state.addressDetails.country;
    currentState['city'] = this.state.addressDetails.city;
    currentState['id'] =
      this.state.addressId !== false ? this.state.addressId : 0;
    currentState['name'] = this.state.addressName;
    currentState['is_primary'] = '1';

    const newAddressParams = Object.assign(
      {},
      currentState,
      { user_id: this.props.userId },
      this.props
    );

    let sameAddressName = false;
    if (this.state.editAddress === false) {
      sameAddressName = isEmpty(get(newAddressParams, 'name', ''))
        ? false
        : (sameAddressName = this.state.addressList.find(obj => {
            if (
              obj.name &&
              obj.name.toLowerCase() === newAddressParams.name.toLowerCase()
            ) {
              return true;
            }
          }));
    }
    if (
      !Required(newAddressParams.name) ||
      checkNumber(newAddressParams.name)
    ) {
      this.refs.alert.error(
        this.props.intl.formatMessage({
          id: 'errorAddressName',
          defaultMessage: defaultMsg.errorAddressName,
        })
      );
    } else if (sameAddressName) {
      this.refs.alert.error(
        this.props.intl.formatMessage({
          id: 'errorAddressNameExists',
          defaultMessage: defaultMsg.errorAddressNameExists,
        })
      );
    } else {
      this.setState({
        savingAddress: true,
      });
      saveUserAddress(newAddressParams)
        .then(response => {
          const apiResponse = get(response, 'data.DataResponse', {});
          if (apiResponse.status === 'success') {
            const primaryAddress = this.makeAddressPipeSeparated(
              find(apiResponse.data, item => item['is_primary'] === '1')
            );
            this.setState(
              Object.assign(
                {
                  addressList: apiResponse.data,
                  listAddress: true,
                  newAddress: false,
                  loading: false,
                  errorLoadingAddress: true,
                  savingAddress: false,
                  editAddress: false,
                },
                this.getAddressObject(primaryAddress)
              )
            );
          } else {
            this.refs.alert.error(apiResponse.msg || ServerErrors[505]);
          }
        })
        .catch(error => {});
    }
  }

  renderDeliveryInformation() {
    return this.props.deliveryInformation ? (
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <table className="table font-small">
          <tbody className="no-padding-left-right">
            <tr>
              <td>
                <FormattedMessage
                  id="deliveryDistance"
                  defaultMessage={defaultMsg.deliveryDistance}
                />
              </td>
              <td>{this.props.deliveryInformation.delivery_distance}</td>
            </tr>
            <tr>
              <td>
                <FormattedMessage
                  id="deliveryFees"
                  defaultMessage={defaultMsg.deliveryFees}
                />
              </td>
              <td>
                {parsePrice(this.props.deliveryInformation.delivery_fees)}
              </td>
            </tr>
            <tr>
              <td>
                <FormattedMessage
                  id="estimatedDeliveryTime"
                  defaultMessage={defaultMsg.estimatedDeliveryTime}
                />
              </td>
              <td>{this.props.deliveryInformation.delivery_time}</td>
            </tr>
            <tr>
              <td colSpan="2">
                <button
                  className="btn customButton "
                  type="button"
                  onClick={this.props.orderNow}
                  style={{
                    width: 'auto',
                    minWidth: '200px',
                    marginTop: '20px',
                  }}
                >
                  <FormattedMessage
                    id="orderNow"
                    defaultMessage={defaultMsg.orderNow}
                  />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    ) : this.props.noDeliveryToUserLocation ? (
      <div
        className="col-md-12 font-medium text-danger text-center"
        style={{
          borderTop: '1px solid #e5e5e5',
          padding: '20px 0px',
        }}
      >
        <FormattedMessage
          id="noDelivery"
          defaultMessage={defaultMsg.noDelivery}
        />
      </div>
    ) : null;
  }

  renderAddress(data) {
    if (data['address_1'] !== 'undefined undefined') {
      return (
        <div
          key={uniqueId('address-key-' + data.id)}
          className="col-md-6 col-lg-6 col-sm-12 col-xs-12"
        >
          <div className="panel address-panel">
            <div className="panel-body">
              <div className="row">
                <div className="olo-client-theme-color col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div className="pull-left">{data.name}</div>
                  <div className="pull-right text-right">
                    <Radio
                      checked={data.is_primary === '1'}
                      value={this.makeAddressPipeSeparated(data)}
                    />
                  </div>
                </div>
                <div className="address-box col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  {addressToString(data)}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const buttonStyles = {
      padding: '2px 6px',
      marginLeft: '4px',
      display: 'inline-block',
    };

    const edit =
      !this.state.savingAddress && this.props.searchingLocation !== true ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tooltip">
              <FormattedMessage id="edit" defaultMessage={defaultMsg.edit} />
            </Tooltip>
          }
        >
          <button
            onClick={this.editDeliveryAddress}
            type="button"
            className="btn btn-default alignCenter inactive font-small"
            style={buttonStyles}
          >
            <span className="fa fa-pencil" />
          </button>
        </OverlayTrigger>
      ) : null;

    const buttonWidth = {
      width: 'auto',
    };

    const cancel =
      this.props.targettingOneLocation !== true &&
      !this.state.savingAddress &&
      this.props.searchingLocation !== true ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip">Back</Tooltip>}
        >
          <button
            onClick={this.props.cancel}
            type="button"
            className="btn btn-default alignCenter inactive font-small"
            style={buttonStyles}
          >
            <span className="fa fa-times" />
          </button>
        </OverlayTrigger>
      ) : (
        ''
      );

    return (
      <div>
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="alert"
          className="toast-top-right"
        />
        {!isEmpty(this.props.userId) && this.state.loading === false ? (
          <ul className="nav nav-tabs" style={{ marginTop: '-15px' }}>
            <li
              className={
                this.state.listAddress && !this.state.shortAddress
                  ? 'active'
                  : ''
              }
            >
              <a
                href="javascript:void(0);"
                onClick={
                  this.props.searchingLocation !== true
                    ? this.selectNewList
                    : ''
                }
              >
                <FormattedMessage
                  id="selectAddress"
                  defaultMessage={defaultMsg.selectAddress}
                />
              </a>
            </li>
            <li
              className={
                (this.state.newAddress || !this.state.listAddress) &&
                !this.state.editAddress &&
                !this.state.shortAddress
                  ? 'active'
                  : ''
              }
            >
              <a
                href="javascript:void(0);"
                onClick={
                  this.props.searchingLocation !== true
                    ? this.selectNewAddress
                    : ''
                }
              >
                <FormattedMessage
                  id="newAddress"
                  defaultMessage={defaultMsg.newAddress}
                />
              </a>
            </li>
            {this.state.editAddress ? (
              <li className=" active">
                <a href="javascript:void(0);">
                  <FormattedMessage
                    id="editAddress"
                    defaultMessage={defaultMsg.editAddress}
                  />
                </a>
              </li>
            ) : null}
          </ul>
        ) : null}

        {this.state.shortAddress ? (
          <div className="row">
            <br />
            <div className="col-md-12 title">
              <b>
                <span className="fa fa-map-marker far" />
                <FormattedMessage
                  id="deliveryTo"
                  defaultMessage={defaultMsg.deliveryTo}
                />
              </b>
              <span className="pull-right">
                {edit}
                {cancel}
              </span>
            </div>
            <div className="col-md-12 margin-bottom-10 font-small">
              {this.state.deliveryAddress}
            </div>
            {this.renderDeliveryInformation()}
          </div>
        ) : (
          <div>
            <div className="text-center">
              {this.state.loading === true ? <MdLoaderTheme /> : null}
            </div>
            <div className="row">
              {this.state.listAddress && !this.state.loading ? (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  {this.state.addressList.length ? (
                    <div
                      ref="listOfUsers"
                      style={{
                        maxHeight: '400px',
                        overflow: 'auto',
                      }}
                      className="row"
                    >
                      <RadioGroup
                        name="addressList"
                        selectedValue={this.state.selectedValue}
                        onChange={this.handleAddressRadioChange}
                      >
                        {this.state.addressList.map(data =>
                          this.renderAddress(data)
                        )}
                      </RadioGroup>
                    </div>
                  ) : (
                    <div className="empty-result-set">
                      <FormattedMessage
                        id="noResultsFound"
                        defaultMessage={defaultMsg.noResultsFound}
                      />
                      <button
                        type="button"
                        onClick={this.selectNewAddress}
                        className="btn-link font-small"
                      >
                        <FormattedMessage
                          id="clickToAddNewAddress"
                          defaultMessage={defaultMsg.clickToAddNewAddress}
                        />
                      </button>
                    </div>
                  )}
                </div>
              ) : null}
            </div>
            <div className="row">
              <div>
                {!isEmpty(this.props.userId) &&
                !this.state.listAddress &&
                this.state.loading === false ? (
                  <FormGroup>
                    <Col lg={12} sm={12} md={12} xs={12}>
                      <label>
                        <FormattedMessage
                          id="enterAddressName"
                          defaultMessage={defaultMsg.enterAddressName}
                        />
                      </label>
                      <FormControl
                        type="text"
                        placeholder={this.props.intl.formatMessage({
                          id: 'placeholderEnterAddressName',
                          defaultMessage:
                            defaultMsg.placeholderEnterAddressName,
                        })}
                        onChange={this.handleAddressNameChange}
                        value={this.state.addressName}
                      />
                    </Col>
                  </FormGroup>
                ) : null}
              </div>
              <div>
                {this.state.listAddress === false &&
                this.state.loading === false ? (
                  <FormGroup>
                    <Col lg={12} sm={12} md={12} xs={12}>
                      <span className="pull-right">{cancel}</span>
                      <label>
                        <span className="fa fa-dot-circle-o far" />
                        <FormattedMessage
                          id="enterZipCodeOrPostalCode"
                          defaultMessage={defaultMsg.enterZipCodeOrPostalCode}
                        />
                      </label>
                      <FormControl
                        type="text"
                        placeholder={this.props.intl.formatMessage({
                          id: 'placeholderEnterZipCodeOrPostalCode',
                          defaultMessage:
                            defaultMsg.placeholderEnterZipCodeOrPostalCode,
                        })}
                        onChange={this.handleZipCodeChange}
                        value={this.state.zipCode}
                        name={this.state.address_1}
                      />
                    </Col>
                  </FormGroup>
                ) : null}
              </div>

              {(this.state.collapsed === false || !this.state.newAddress) &&
              !this.state.loading ? (
                <div>
                  {this.state.listAddress === false &&
                  this.state.collapsed === false ? (
                    <FormGroup controlId="locationHeader">
                      {!isEmpty(this.props.userId) ? (
                        <div>
                          <Col md={12} lg={12} sm={12} xs={12}>
                            <label>
                              <span className="fa fa-road far" />
                              <FormattedMessage
                                id="enterStreetAddress"
                                defaultMessage={defaultMsg.enterStreetAddress}
                              />
                            </label>
                            <FormControl
                              type="text"
                              placeholder={this.props.intl.formatMessage({
                                id: 'placeholderEnterStreetAddress',
                                defaultMessage:
                                  defaultMsg.placeholderEnterStreetAddress,
                              })}
                              value={this.state.streetAddress}
                              onChange={this.handleStreetAddress}
                            />
                          </Col>
                          <Col md={12} lg={12} sm={12} xs={12}>
                            <label>
                              <span className="fa fa-building far" />
                              <FormattedMessage
                                id="enterApartmentOrBuildingAddress"
                                defaultMessage={
                                  defaultMsg.enterApartmentOrBuildingAddress
                                }
                              />
                            </label>
                            <FormControl
                              type="text"
                              placeholder={this.props.intl.formatMessage({
                                id:
                                  'placeholderEnterApartmentOrBuildingAddress',
                                defaultMessage:
                                  defaultMsg.placeholderEnterApartmentOrBuildingAddress,
                              })}
                              value={this.state.appartmentAddress}
                              onChange={this.handleAppartmentAddress}
                            />
                          </Col>
                        </div>
                      ) : (
                        <Col md={12} lg={12} sm={12} xs={12}>
                          <label>
                            <span className="fa fa-road far" />
                            <FormattedMessage
                              id="whereAreYouLocated"
                              defaultMessage={defaultMsg.whereAreYouLocated}
                            />
                          </label>
                          <FormControl
                            componentClass="textarea"
                            placeholder={this.props.intl.formatMessage({
                              id: 'placeholderEnterCompleteAddress',
                              defaultMessage:
                                defaultMsg.placeholderEnterCompleteAddress,
                            })}
                            value={this.state.streetAddress}
                            onChange={this.handleStreetAddress}
                            style={{ resize: 'none' }}
                          />
                        </Col>
                      )}
                    </FormGroup>
                  ) : null}
                  <FormGroup>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {this.state.listAddress === false &&
                      this.state.collapsed === false ? (
                        <HelpBlock>
                          {!this.state.deliveryAddress
                            ? this.state.formattedAddress
                            : this.state.deliveryAddress}
                        </HelpBlock>
                      ) : null}
                      <div className="checkAvailabilityWidth">
                        {(this.state.newAddress || this.state.editAddress) &&
                        !isEmpty(this.props.userId) ? (
                          <button
                            type="button"
                            id="addAddress"
                            className="btn btn-success greenBtn checkAvailability"
                            onClick={
                              !this.state.savingAddress ? this.saveAddress : ''
                            }
                            disabled={this.state.savingAddress}
                          >
                            {this.state.savingAddress ? (
                              <FormattedMessage
                                id="savingAddress"
                                defaultMessage={defaultMsg.savingAddress}
                              />
                            ) : (
                              <FormattedMessage
                                id="saveAddress"
                                defaultMessage={defaultMsg.saveAddress}
                              />
                            )}
                          </button>
                        ) : (
                          <button
                            type="button"
                            id="deliveryAvailability"
                            className="btn btn-success greenBtn checkAvailability"
                            onClick={this.getAddresses}
                          >
                            <FormattedMessage
                              id="checkAvailability"
                              defaultMessage={defaultMsg.checkAvailability}
                            />
                          </button>
                        )}
                      </div>
                    </Col>
                  </FormGroup>
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tokenId: getTokenId(state),
  jwt: getJWT(state),
  userId: getUserId(state),
  userLocatedAddress: state.dashboard.userLocation.address,
});

export default connect(mapStateToProps)(injectIntl(DeliveryAddressForm));
//export default DeliveryAddressForm;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/orderType/DeliveryAddressForm.jsx